import { ID_IMAGE, ID_IMAGE_SELFIE, ALERT_MODAL, UPLOAD_IMG, UNDER_CONSTRUCTION_MODAL } from "./action";

const initialState = {
    joinGuide: {
        imageID: null,
        imageSelfieID: null
    },
    alert: {
        content: null,
        title: null,
        show: false,
    },
    underConstruction: {
        content: null,
        title: null,
        show: false,
    },
    uploadedIMG: null,
};
function generalReducer(state = initialState, action: { type: any; payload: any; }) {
    let guide = state.joinGuide;
    switch (action.type) {
        case ID_IMAGE:
            guide.imageID = action.payload;
            return { ...state, joinGuide: guide };
        case ALERT_MODAL:
            return { ...state, alert: action.payload };
        case UNDER_CONSTRUCTION_MODAL:
            return { ...state, underConstruction: action.payload };
        case ID_IMAGE_SELFIE:
            guide.imageSelfieID = action.payload;
            return { ...state, joinGuide: guide };
        case UPLOAD_IMG:
            return { ...state, uploadedIMG: action.payload };
        default:
            return state;
    }
}
export default generalReducer;
